// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2J3JT","toggleWrap":"styles_toggleWrap__xKHu9","content":"styles_content__yf_l4","selectAreaCode":"styles_selectAreaCode__14Bmj"};